import { CUSTOMER_JOURNEY_NEWS_CATEGORY_SUCCESS } from '../const';

function action(data) {
  return { type: CUSTOMER_JOURNEY_NEWS_CATEGORY_SUCCESS, data };
}

module.exports = action;



// WEBPACK FOOTER //
// ./actions/customerJourney/customerJourneyNewsCategorySuccess.js